import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import {
  getApprovedAndVoidTrainingApplications,
  voidTrainingApplications,
} from "../../../api/trainingApplicationApprovalApi";
import ApprovedTrainingApplicationVoidForm from "../../forms/Training/ApprovedTrainingApplicationVoidForm";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function ApprovedTrainingApplicationVoidPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [trainingApplications, setTrainingApplications] = useState([]);
  const [selectedTrainingApplications, setSelectedTrainingApplications] =
    useState([]);
  const [currentYear, setCurrentYear] = useState(dayjs().year());
  const [pagination, setPagination] = useState({
    current: 1,
    minIndex: 0,
    maxIndex: 100,
    pageSize: 100,
  });

  useEffect(getTrainingApplications, [currentYear]);

  function getTrainingApplications() {
    setIsLoading(true);
    getApprovedAndVoidTrainingApplications(currentYear)
      .then((value) => {
        // reset pagination
        resetPagination();

        setTrainingApplications(value ? value : []);
        setSelectedTrainingApplications([]);
        setIsLoading(false);
      })
      .catch((error) => {
        showErrorMessage(t("general.fail_to_load_record"), error);
      });
  }

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  function onAddNewTrainingApplication() {
    history("/home/trainingapplication/trainingtrans");
  }

  function onVoidTrainingApplications(selectedTrainingApplications, reason) {
    setIsLoading(true);

    voidTrainingApplications(selectedTrainingApplications, reason)
      .then(() => {
        getTrainingApplications();
        toast.success(t("general.record_voided_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_void_record"), error);
      });
  }

  function viewTrainingApplications(trainingApplicationKey) {
    history(
      "/home/trainingapplication/trainingtrans/" + trainingApplicationKey,
      { state: { fromVoid: true } }
    );
  }

  function viewTrainingProgram(trainingKey) {
    history("/home/trainings/training/" + trainingKey, {
      state: {
        fromVoid: true,
        fromList: true,
      },
    });
  }

  function showErrorMessage(message, error) {
    let errorMsg = error.response.data.error_description
      ? error.response.data.error_description
      : error.response.data.ExceptionMessage;

    toast.error(message + (errorMsg ? errorMsg : ""));
  }

  return (
    <ApprovedTrainingApplicationVoidForm
      isLoading={isLoading}
      data={trainingApplications}
      selectedItems={selectedTrainingApplications}
      onAdd={onAddNewTrainingApplication}
      onView={viewTrainingApplications}
      onViewProgram={viewTrainingProgram}
      onVoided={onVoidTrainingApplications}
      onItemSelected={setSelectedTrainingApplications}
      setCurrentYear={setCurrentYear}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
}

ApprovedTrainingApplicationVoidPage.propTypes = {
  history: PropTypes.func.isRequired,
};
